export const useEmptyResults = () => {
    // Handler for when the clear filters button is clicked
    const handleClearFilters = () => {
        try {
            document.querySelector("#categories-clear-button").click();
        } catch (err) {
            console.error("Error while clearing categories.");
        }
    }

    return {
        handleClearFilters
    }
}